import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { isValidValue } from "utils/validators";

export const TimeCellFormatter = ({ value }) => {
  if (!isValidValue(value)) {
    return <span />;
  }
  return (
    <span title={ moment(value).fromNow() }>{moment(value).format("DD/MM/YY [at] h:mm a")}</span>
  );
};

TimeCellFormatter.defaultProps = {
  value: moment().format("DD/MM/YY")
};

TimeCellFormatter.propTypes = {
  value: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/js/components/grid/cell-formatters/time-cell-formatter.jsx